import { Header } from '@/components/Header'
import { Hero } from '@/components/Hero'
import { Pillars } from '@/components/Pillars'
import { Talleres } from '@/components/Talleres'
import { Empresas } from '@/components/Empresas'
import { SobreMi } from '@/components/SobreMi'
import { Recursos } from '@/components/Recursos'
import { Contenido } from '@/components/Contenido'
import { Contacto } from '@/components/Contacto'
import { Footer } from '@/components/Footer'
import { useReveal } from '@/hooks/useReveal'

function App() {
  useReveal()

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Pillars />
        <Talleres />
        <Empresas />
        <SobreMi />
        <Recursos />
        <Contenido />
        <Contacto />
      </main>
      <Footer />
    </>
  )
}

export default App
